import $ from 'jquery';
import axios from "axios";

$(function() {

    initModalAssetControls();

    //initSupplierPortalAssetUpload();

});


function initModalAssetControls() {

    $('#add-asset-sticky button').unbind('click');
    $('#add-asset-sticky button').on('click', function() {

        return axios.post('/account/supplier-portal/products/assets/modal', {
            assetId: null
        }).then(function (response) {
            console.log(response);
            if (response.data) {
                $('#modal-asset-wrapper').html(response.data);
                $('#modal-asset-wrapper').addClass('show');
                initModalClose();
                initSupplierPortalAssetUpload();
            }
        })
            .catch(function (error) {
                console.log(error);
            });

    });

    $('.supplier-portal-asset-tile .actions button').unbind('click');
    $('.supplier-portal-asset-tile .actions button').on('click', function() {

        let assetId = $(this).attr('data-asset-id');

        if ($(this).hasClass('edit')) {

            return axios.post('/account/supplier-portal/products/assets/modal', {
                assetId: assetId
            }).then(function (response) {
                console.log(response);
                if (response.data) {
                    $('#modal-asset-wrapper').html(response.data);
                    $('#modal-asset-wrapper').addClass('show');
                    initModalClose();
                    //initSupplierPortalAssetUpload();
                }
            }).catch(function (error) {
                console.log(error);
            });

        } else if ($(this).hasClass('delete')) {

            if (confirm('Are you sure you want to delete this image?') !== true) {
                return;
            }

            return axios.post('/account/supplier-portal/products/assets/delete', {
                assetId: assetId
            }).then(function (response) {
                console.log(response);
                window.location.reload();
            }).catch(function (error) {
                console.log(error);
                window.location.reload();
            });

        }

    });

    // $('.actions-wrapper li').unbind('click');
    // $('.actions-wrapper li').on('click', function() {
    //
    //     let $actions = $(this).closest('.actions');
    //     let assetId = $actions.attr('data-asset-id');
    //
    //     if ($(this).text() === 'Edit') {
    //
    //         return axios.post('/account/supplier-portal/products/assets/modal', {
    //             assetId: assetId
    //         }).then(function (response) {
    //             console.log(response);
    //             if (response.data) {
    //                 $('#modal-asset-wrapper').html(response.data);
    //                 $('#modal-asset-wrapper').addClass('show');
    //                 initModalClose();
    //                 //initSupplierPortalAssetUpload();
    //             }
    //         })
    //             .catch(function (error) {
    //                 console.log(error);
    //             });
    //
    //
    //     } else if ($(this).text() === 'Delete') {
    //
    //         if (confirm('Are you sure you want to delete this image?') !== true) {
    //             return;
    //         }
    //
    //         return axios.post('/account/supplier-portal/products/assets/delete', {
    //             assetId: assetId
    //         }).then(function (response) {
    //             console.log(response);
    //             window.location.reload();
    //         }).catch(function (error) {
    //             console.log(error);
    //             window.location.reload();
    //         });
    //
    //
    //     }
    //
    // });

}


function initModalClose() {

    $('#modal-asset-wrapper .close').unbind('click');
    $('#modal-asset-wrapper .close').on('click', function() {
        $('#modal-asset-wrapper').removeClass('show');
    });

}


function initSupplierPortalAssetUpload() {

    //console.log('initSupplierPortalAssetUpload');

    if ($("#product-asset-upload").length == 0) {
        return false;
    }

    $("#product-asset-upload").dropzone({
        maxFilesize: (25 * 1024 * 1024),
        filesizeBase: 1000,
        maxFiles: 1,
        acceptedFiles: productAssetUploadMimes,
        autoProcessQueue: false,
        init: function () {

            let dz = this;

            $('#product-asset-upload-submit').click(function(e) {
                e.preventDefault();
                dz.processQueue();
            });

            dz.on('sending', function(file, xhr, formData) {
                // Append all form inputs to the formData
                let data = $('#product-asset-upload').serializeArray();
                $.each(data, function(key, el) {
                    formData.append(el.name, el.value);
                });
            });

        },
        success: function(file, response) {
            console.log(response);
            window.location.reload();

            //console.log('success');
            //console.log(response);
            //window.location.reload();
            //updateAssetTable(response);
        },
        error: function(file, response) {
            console.log('error');
            console.log(response);
            //window.location.reload();
        }
    });

}

// function updateAssetTable(jsonAssetData) {
//
//     // While this works quite well, it's easier to reload the page as that resets the dropzone too ...
//
//     let assetData = JSON.parse(jsonAssetData);
//
//     if (!Array.isArray(assetData)) {
//         //console.log('Returned data does not decode to an array');
//         return false;
//     }
//
//     // Get the template table
//     let $table = $('#asset-list-template table').clone();
//     $table.find('tbody tr').remove();
//     let $row = $('#asset-list-template table tbody tr').clone();
//     //console.log($row.prop('outerHTML'));
//
//     $.each(assetData, function(index, value) {
//
//         let $newRow = $row.clone();
//
//         $newRow.find('.product-asset-thumbnail').css('background-image', 'url(\'' + value['imageUrl'] + '\')');
//         $newRow.find('.asset-product-code').html(value['productCode']);
//         $newRow.find('.asset-product-name').html(value['productName']);
//         $newRow.find('.asset-product-description').html(value['productDescription']);
//         $newRow.find('.asset-date-uploaded').html(value['dateUploaded']);
//         $newRow.find('.asset-uploaded-by').html(value['uploadedBy']);
//         $newRow.find('.asset-status').html(value['status']);
//
//         $table.find('tbody').append($newRow);
//
//     });
//
//     $('.asset-list .portal-list').remove();
//     $('.asset-list .editorial').remove();
//     $('.asset-list').append($table);
//
// }
